import { useCallback, useEffect, useState } from 'react';
import { getRecharge } from '../services/rechargeService';

/**
 * Hook para gerenciar recargas em andamento.
 *
 * @param token Token de autenticação (se existir).
 */
export function useRecharge(token?: string) {
  const [recharge, setRecharge] = useState<any[]>([]);
  const [loadingRecharge, setLoadingRecharge] = useState(false);
  const [errorRecharge, setErrorRecharge] = useState('');

  const fetchRecharge = useCallback(async () => {
    setLoadingRecharge(true);
    try {
      const recharge = await getRecharge();
      setRecharge(recharge);
      setErrorRecharge('');
    } catch (error) {
      console.error('Erro ao buscar recargas em andamento', error);
      setErrorRecharge('Erro ao buscar recargas em andamento');
    }
    setLoadingRecharge(false);
  }, []);

  useEffect(() => {
    if (token) fetchRecharge();
  }, [token, fetchRecharge]);

  return { recharge, loadingRecharge, errorRecharge, fetchRecharge };
}
